export default __webpack_public_path__ + "static/media/Flag of Turkmenistan.a8a9eb31.gif";